import * as React from "react";
import styled from "styled-components";
import { Alert, Button, Space } from "antd";
import useRtm from "@/hooks/use-rtm";
import { storage } from "@/util";
import { LOGININFOSTORE, METTINGPAGE_SAVED_MEETING_INFO, LOGINTOKEN } from "@/config/const";
import { conference } from "@/api";
import { ConferenceInterface,UserInfo } from "@/types";
import { useHistory } from "react-router-dom";
import { message as antMsg } from "antd";
import { log } from "console";
import isElectron from "is-electron";
 
import { useAuth } from "@/component/Auth";
const Container = styled.div`
  position: fixed;
  left: calc(100wh - 250px);
  top: 40%;
  z-index: 99999999;
`;

const MessageNotify: React.FunctionComponent = () => {
  const auth = useAuth();
  const loginfo: UserInfo = auth.loginfo as UserInfo;
  const { userId } = loginfo;
  const history = useHistory();
  const rtm = useRtm({}, (closedByServer)=>{
    // console.log("[Login] closedByServer", closedByServer);
    // //关闭rtm
    // rtm.logout();
    // //退出登录
    // storage.remove(LOGININFOSTORE);
    // storage.remove(LOGINTOKEN);
    // if (isElectron()) {
    //   alert(`推出登陆!`);
    //   history.replace("/");
    // } else {
    //   window.location.href = "/";
    // }
    // alert("检测到相同账号重复登录，已自动退出!");
  });
  const timerRef = React.useRef<NodeJS.Timeout>(null);
  const [joinConfNo, setjoinConfNo] = React.useState("");

  const [multi, setMulti] = React.useState(false);

  const timerFunc = () => {
    timerRef.current = null;
    setInviter("");
    setShowAlert(false);
  };

  const messageHandler = (evt: any) => {
    // debugger
    const {
      channelName = "", //:  "notification"
      channelType = "", //:  "MESSAGE"
      message = "{}",
      //"{\"action\":\"call\",\"participants\":[\"btbodcdkraakkhf\"],\"room\":\"8608804819\",\"data\":{\"video\":{\"code\":\"H264\",\"resolution\":\"1024X768\"},\"audio\":{\"sampleRate\":\"44100\",\"channels\":2}}}"
      publisher = "",
    } = evt;
    const messageObj = JSON.parse(message);
    
    // 多人聊天模式
    if (
      channelName.toLowerCase() === "notification" &&
      channelType.toLowerCase() === "message"
    ) {
      setMulti(true);
      const saveduserId = storage.get(LOGININFOSTORE)?.userId ?? "";
      if (!saveduserId) return;
      const findedItem = messageObj.participants.find(
        (x: string) => x === saveduserId
      );
      if (!findedItem) return;
      //// 符合条件的
      setInviter(publisher);
      setShowAlert(true);
      setjoinConfNo(messageObj.room);
      timerRef.current = setTimeout(timerFunc, 30000);
      /// 下面单人信息
    } else if (channelType.toLowerCase() === "message") {
      setMulti(false);
      const { action, room, result } = messageObj;
      // 对方接受，进入会议
      if (action === "call") {
        setInviter(publisher);
        setShowAlert(true);
        setjoinConfNo(messageObj.room);
      } else if (action === "response") {
        if (result === "accept") {
          antMsg.warn("Урилга хүлээн авлаа");
          // console.log("对方接受邀请，自己进会");
          join(room);
        } else {
          antMsg.warn("Урилгыг цуцаллаа");

          //
        }
      }
    }
    ///
  };
  // if(userId.)
  React.useEffect(() => {
    
    console.log("rtm addEventListener message!!!!!:::",rtm);
    rtm && rtm.addEventListener("message", messageHandler);
    return () => {
      rtm && rtm.removeEventListener("message", messageHandler);
    };
  }, [userId]);

  const [inviter, setInviter] = React.useState("");
  const [showAlert, setShowAlert] = React.useState(false);

  const accept = (b: boolean) => {
    
    timerFunc();
    if (!multi) {
      console.log("Зөвшөөрсөн хариу илгээх");
      rtm.publishToPeer(
        inviter,
        JSON.stringify({
          action: "response",
          result: b ? "accept" : "decline",
          room: joinConfNo,
        })
      );
    }
    // if (b) console.log("自己接受，自己进会");
    if (b) join();
  };

  const adescription = React.useMemo(
    () => `${inviter} таныг уулзалтад урьж байна, 30н секунд хариу өгөөгүй бол татгалзсанд тооцно`,
    [inviter]
  );

  //// 加入别人的会议
  const join = async (confNum?: string) => {
    const userName = storage.get(LOGININFOSTORE)?.realName ?? "user";
    const con: any = await getConferenceInfo(confNum ?? joinConfNo, userName);
    goMetting(con, userName);
  };

  const getConferenceInfo = async (
    conferenceNo: string,
    userName: string,
    password?: string
  ) => {
    try {
       
      const ret = await conference.conferenceJoin(
        {
          conferenceNo,
          userName,
          password,
        },
        {
          "X-Conference-No": conferenceNo, //	${conferenceNo}	会议号
          "X-Device": "1", //	8
        }
      );
      //需要先判断ret的code是200还是600xxx
      console.log(`[JoinMeeting] ret=${JSON.stringify(ret)}`);
      const con = ret.conference as ConferenceInterface;
      con.attendList = ret.attendList;
      con["X-Channel-Token"] = ret["X-Channel-Token"];
      con["X-Conference-Token"] = ret["X-Conference-Token"];
      con.roleCode = ret.roleCode;
      con.roomid = ret.roomid;
      con.roleName = ret.roleName;
      con.userId = ret.userid;
      return con;
    } catch (e) {
      return e;
    }
  };

  const goMetting = async (conf: ConferenceInterface, userName: string) => {
    storage.save(METTINGPAGE_SAVED_MEETING_INFO, conf);
    const url = `#/meeting/${conf.roomId}?username=${userName}&audio=true&video=true&speaker=true`;
    window.location.href = url;
  };

  return (
    <Container>
      {showAlert && (
        <Alert
          message="Уулзалтын урилга"
          description={adescription}
          type="info"
          action={
            <Space direction="vertical">
              <Button size="small" type="primary" onClick={() => accept(true)}>
                Хүлээн авах
              </Button>
              <Button size="small" danger ghost onClick={() => accept(false)}>
                Татгалзах
              </Button>
            </Space>
          }
        />
      )}
    </Container>
  );
};

export default MessageNotify;
